import React, { useState, useEffect } from 'react';
import '../../css/linkCardStepMbWaySuccessful.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import ImgIconSuccess from '../../assets/svg/iconSuccess.svg';
import mainImgSuccess from '../../assets/img/onboarding/desktop/img-carteira-ja-esta-ativa.jpg';
import mainImgSuccessTablet from '../../assets/img/onboarding/tablet/img-carteira-ja-esta-ativa.jpg';
import mainImgSuccessMobile from '../../assets/img/onboarding/mobile/img-carteira-ja-esta-ativa.jpg';
import CustomButton from '../../components/CustomButton';
import GifIconLoading from '../../assets/gif/mainLoading.gif';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Heading from '../../components/Heading';
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';
import { useDispatch, useSelector } from 'react-redux';
import { setCookieId, setSessionId, setNAssocia } from '../../features/onboardingData/onboardingUserData';
import { toast } from "react-toastify";
import { AiOutlineStop } from "react-icons/ai";
import { errorHandling } from '../../utils';
import { removeSecureData } from '../../utils/secureStorage';

function LinkCardStepMbWaySuccessful() {

    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isNAssocia = useSelector((state) => state.onboardingUserData.isNAssocia);
    const [isStartingLoadingAnim, setIsStartingLoadingAnim] = useState(true);
    const [isConfirmAddCardMbWay, setIsConfirmAddCardMbWay] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [progress, setProgress] = useState(0);
    const [progressConfirmAddCardMbWay, setProgressConfirmAddCardMbWay] = useState(0);
    const [isConfirmAssociaCarteira, setConfirmAssociaCarteira] = useState(true);

    const getInfoGeral = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/getInfoGeral/fetchGetInfoGeral`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                'nAssocia': `${isNAssocia}`,
            },
            credentials: "include",
            mode: "cors",
          });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setConfirmAssociaCarteira(result.mantemLoading);
                dispatch(setNAssocia('1'));
                removeSecureData('isNAssocia');
            } else {
                hadleNavMbWay();
            }
        } catch (error) {
            hadleNavMbWay();
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
            errorHandling('CORS');
            } else {
            errorHandling();
            }
        }
      }

      useEffect(() => {
        // Interval to call getInfoGeral every 10 seconds
        const fetchIntervalId = setInterval(() => {
            getInfoGeral();
        }, 10000); // 10 seconds
    
        // Interval to update the progress bar every 3 seconds
        const progressIntervalId = setInterval(() => {
            setProgressConfirmAddCardMbWay(prevProgress => {
                const newProgress = prevProgress + 1; // Progress by 1 each interval
                if (newProgress >= 100 || !isConfirmAssociaCarteira) {
                    clearInterval(progressIntervalId); // Stop progress interval
                    clearInterval(fetchIntervalId); // Stop fetching interval
                    setIsConfirmAddCardMbWay(true); // Mark as complete
                }
                return newProgress;
            });
        }, 3000); // 3 seconds to reach 100 in 5 minutes
    
        // Clear intervals after 5 minutes
        const timeoutId = setTimeout(() => {
            clearInterval(fetchIntervalId);
            clearInterval(progressIntervalId);
            if (!isConfirmAddCardMbWay) {
                hadleNavMbWay();
            };
        }, 300000); // 5 minutes = 300000 milliseconds
    
        // Clean up on component unmount
        return () => {
            clearInterval(fetchIntervalId);
            clearInterval(progressIntervalId);
            clearTimeout(timeoutId);
        };
    }, [isConfirmAssociaCarteira]);
    

    useEffect( () => {
        if (!isConfirmAddCardMbWay) return;
        /* const fetchDataWithDelay = () => {
            setTimeout(() => {
                fetchData();
            }, 5000);
        };
    
        fetchDataWithDelay(); */
        const intervalId = setInterval(() => {
            setProgress(preProgress => {
                const newProgress = preProgress + 1;
                if (newProgress >= 100) {
                    fetchData();
                    clearInterval(intervalId);
                }
                return newProgress;
            });
        }, 50);
        return () => clearInterval(intervalId);
    }, [isConfirmAddCardMbWay]);

    const hadleBtnClickGoHome = () => {
        navigate('/');
    };

    const hadleBtnClickSeePartners = () => {
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros');
    };

    const hadleNavMbWay = () => {
        removeSecureData('isNAssocia');
        dispatch(setNAssocia('1'));
        toast.error("Lamentamos, mas neste momento, não foi possivel associar o seu cartão via MBWay. Por favor, tente mais tarde.", {
            icon: <AiOutlineStop/>
        });
        navigate('/configuracoes/associar-cartao/mbway');
    };

    const fetchData = async () => {
        try {
            setIsStartingLoadingAnim(true);
            if (isConfirmAddCardMbWay) {
                setIsStartingLoadingAnim(false);
            } else {
                hadleNavMbWay();
                setIsStartingLoadingAnim(false);
            }
        } catch (error) {
            hadleNavMbWay();
            setIsStartingLoadingAnim(false);
        }
    };

  return (  
    <>
    <Header/> 
    <div className={ isTablet ? "mainViewContainerLinkCardStepMbWaySuccessful" : ( isMobile ? "mainViewContainerLinkCardStepMbWaySuccessfulTablet" : "mainViewContainerLinkCardStepMbWaySuccessfulMobile")}>
        <div className={ isTablet ? 'firstTxtViewContainerLinkCardStepMbWaySuccessful' : ( isMobile ? 'firstTxtViewContainerLinkCardStepMbWaySuccessfulTablet' : 'firstTxtViewContainerLinkCardStepMbWaySuccessfulMobile') }>
            <div className='mainHeadingViewContainerLinkCardStepMbWaySuccessful'>           
                <CustomBreadcrumbs hasBtnBack={false} />
                <Heading hasBtnBack={false} />
            </div>
            { !isStartingLoadingAnim ? (
                <>
                <div className={ isTablet ? 'mainContentViewContainerLinkCardStepMbWaySuccessful' : 'mainContentViewContainerLinkCardStepMbWaySuccessfulMobile' }>
                    <div className='titleViewContentViewContainerLinkCardStepMbWaySuccessful'>
                        { isTablet &&
                        <div className="imgViewContainerLinkCardStepMbWaySuccessful">
                            <img src={ImgIconSuccess} alt="icon" className="imgContainerLinkCardStepMbWaySuccessful" />
                        </div>
                        }
                        <div className={ isTablet ? 'txtTitleViewContainerLinkCardStepMbWaySuccessful' : 'txtTitleViewContainerLinkCardStepMbWaySuccessfulMobile' }>Cartão associado com sucesso!</div>
                        <div className={ isTablet ? 'txtRegularViewContainerLinkCardStepMbWaySuccessful' : 'txtRegularViewContainerLinkCardStepMbWaySuccessfulMobile' }>Comece já a acumular saldo ao comprar <br/> na rede de parceiros da Carteira Virtual.</div>
                    </div>
                    <div className='mainImgViewContentViewContainerLinkCardStepMbWaySuccessful'>
                        <div className={ isTablet ? 'manImgViewContainerLinkCardStepMbWaySuccessful' : 'manImgViewContainerLinkCardStepMbWaySuccessfulMobile'}>
                            <img src={ isTablet ? mainImgSuccess : ( isMobile ? mainImgSuccessTablet : mainImgSuccessMobile) } alt="icon" className={ isTablet ? 'mainImgContainerLinkCardStepMbWaySuccessful' : ( isMobile ? 'mainImgContainerLinkCardStepMbWaySuccessfulTablet' : 'mainImgContainerLinkCardStepMbWaySuccessfulMobile' )} />
                        </div>
                    </div>
                    <div className={ isTablet ? 'rowBtnViewContentViewContainerLinkCardStepMbWaySuccessful' : 'columnBtnViewContentViewContainerLinkCardStepMbWaySuccessfulMobile'}>
                        <CustomButton 
                            text={'Página principal'} 
                            textColor={'#00214D'}
                            onPress={hadleBtnClickGoHome} 
                            borderColor={'#00214D'}
                            hasShadow={false}
                        />
                        <CustomButton 
                        text={'Ver parceiros'} 
                        textColor={'#00214D'}
                        onPress={hadleBtnClickSeePartners} 
                        color={'#15D4B6'}
                        hasArrow
                        iconColor={'#00214D'}
                    />
                    </div>
                </div>
                </>
                ) : ( isConfirmAddCardMbWay ?
                (
                <div className={ isTablet ? 'mainContentViewContainerLinkCardStepMbWaySuccessful' : 'mainContentViewContainerLinkCardStepMbWaySuccessfulMobile' }>
                    <div className='mainLoadingViewContainerLinkCardStepMbWaySuccessful'>
                        <div style={{ alignSelf: 'center', textAlign: 'center' }}>
                            <span className={ isTablet ? 'mainLoadingTxtTitleBoldLinkCardStepMbWaySuccessful' : 'txtTitleViewContainerLinkCardStepMbWaySuccessfulMobile' }>Aguarde </span>
                            <span className={ isTablet ? 'mainLoadingTxtTitleRegularLinkCardStepMbWaySuccessful' : 'txtTitleViewContainerLinkCardStepMbWaySuccessfulMobile' }>um momento</span>
                        </div>
                        <div className={ isTablet ? 'mainLoadingTxtRegularLinkCardStepMbWaySuccessful' : 'txtRegularViewContainerLinkCardStepMbWaySuccessfulMobile' }>{`Aguarde um momento, estamos a validar a sua adesão (...)`}</div>
                    </div>
                    <div className='mainLoadingViewContainerLinkCardStepMbWaySuccessful'>
                        <ProgressBar animated now={progress} className="mainProgressBarViewLinkCardStepMbWaySuccessful"  />
                    </div>
                    <div className={ isTablet ? 'manImgViewContainerLinkCardStepMbWaySuccessful' : 'manImgViewContainerLinkCardStepMbWaySuccessfulMobile'}>
                        <img src={GifIconLoading} alt="gif" className={ isTablet ? 'mainGifContainerLinkCardStepMbWaySuccessful' : 'mainGifContainerLinkCardStepMbWaySuccessfulMobile' } />
                    </div>
                </div>
                ) : (
                <div className={ isTablet ? 'mainContentViewContainerLinkCardStepMbWaySuccessful' : 'mainContentViewContainerLinkCardStepMbWaySuccessfulMobile' }>
                    <div className='mainLoadingViewContainerLinkCardStepMbWaySuccessful'>
                        <div style={{ alignSelf: 'center', textAlign: 'center' }}>
                            <span className={ isTablet ? 'mainLoadingTxtTitleBoldLinkCardStepMbWaySuccessful' : 'txtTitleViewContainerLinkCardStepMbWaySuccessfulMobile' }>Termine </span>
                            <span className={ isTablet ? 'mainLoadingTxtTitleRegularLinkCardStepMbWaySuccessful' : 'txtTitleViewContainerLinkCardStepMbWaySuccessfulMobile' }>a associação na app</span>
                        </div>
                        <div className={ isTablet ? 'mainLoadingTxtRegularLinkCardStepMbWaySuccessful' : 'txtRegularViewContainerLinkCardStepMbWaySuccessfulMobile' }>{`Abra a aplicação MBWay no seu telemóvel e complete o processo de associação à carteira virtual Médis. A aguardar ...`}</div>
                    </div>
                    <div className='mainLoadingViewContainerLinkCardStepMbWaySuccessful'>
                        <ProgressBar animated now={progressConfirmAddCardMbWay} className="mainProgressBarViewLinkCardStepMbWaySuccessful"  />
                    </div>
                    
                </div>
                )
            )}
        </div>
    </div>
    <Footer/> 
    </>
  )
}

export default LinkCardStepMbWaySuccessful;